import { appState, dispatchStateEvent } from '../../store/appState.js';
import { createWalletFull } from '../../api/wallets.js';
import { showToast } from '../../utils/toast.js';
import { renderWalletsTab } from '../tabs/walletsTab.js';

export function initAddWalletModal() {
    const addWalletModal = document.getElementById('add-wallet-modal');
    const inputWalletBalance = document.getElementById('new-wallet-balance');
    const displayNewCurrency = document.getElementById('display-new-currency');

    if(!addWalletModal) return;

    // Định dạng ô nhập tiền y hệt Form chính
    inputWalletBalance.addEventListener('blur', () => {
        let val = inputWalletBalance.value.replace(/,/g, '').replace(/[^\d.-]/g, '');
        if (val) inputWalletBalance.value = Number(val).toLocaleString('en-US');
    });
    inputWalletBalance.addEventListener('focus', () => {
        inputWalletBalance.value = inputWalletBalance.value.replace(/,/g, '');
    });

    // Bật/Tắt Modal
    document.getElementById('btn-add-wallet').addEventListener('click', () => {
        addWalletModal.classList.remove('hidden');
        addWalletModal.classList.add('flex');
    });
    
    document.getElementById('btn-close-add-wallet').addEventListener('click', () => {
        addWalletModal.classList.add('hidden');
        addWalletModal.classList.remove('flex');
    });

    // Lưu Ví Mới
    document.getElementById('btn-save-add-wallet').addEventListener('click', async () => {
        const name = document.getElementById('new-wallet-name').value.trim();
        const type = document.getElementById('new-wallet-type').value;
        const currency = displayNewCurrency.getAttribute('data-currency');
        const balanceStr = inputWalletBalance.value.replace(/,/g, '');
        const balance = Number(balanceStr) || 0;

        if (!name) { showToast('Please enter Wallet Name!', 'error'); return; }

        const btn = document.getElementById('btn-save-add-wallet');
        btn.innerText = "Saving..."; btn.disabled = true;

        const newWallet = await createWalletFull(name, type, currency, balance);

        if (newWallet) {
            showToast('Wallet created successfully!', 'success');
            document.getElementById('new-wallet-name').value = '';
            inputWalletBalance.value = '';
            addWalletModal.classList.add('hidden');
            addWalletModal.classList.remove('flex');
            
            // Reload tất cả tabs để cập nhật số dư, dashboard...
            if (window.refreshAllActiveViews) window.refreshAllActiveViews();
        } else {
            showToast('Failed to create wallet.', 'error');
        }
        btn.innerText = "Save Wallet"; btn.disabled = false;
    });
}
